import { useState } from 'react'
import dataSelectField from '@templates/AddNewItemModal/templates/dataSelectField'
import { useGetDangerObjectsQuery } from '@services/dangerObjects'
import { UseDangerField } from '@app-types/riskMapFields'

const useDangerObjectsField: UseDangerField = ({
  params,
  onOneItem,
  skip,
  initFilters,
}) => {
  const [filters, setFilters] = useState(initFilters)

  return {
    setFilters,
    field: (fieldParams) =>
      dataSelectField({
        query: useGetDangerObjectsQuery,
        filters,
        setFilters,
        dropdownWidth: 500,
        label: 'Объект возникновения опасности',
        name: 'object',
        withManualEntryText: true,
        withShowLabelInDescription: true,
        onOneItem,
        skip,
        ...params,
        ...fieldParams,
      }),
  }
}

export default useDangerObjectsField
